import React, {useState} from 'react';

import {apiPostFile, getMerchantsApiUrl} from '../common/AppApi';
import Processing from '../common/Processing';
import MessageTag from '../common/MessageTag';
import Strings from '../common/Strings';
import useUserContext from '../common/UserContext';

export default function MerchantFile() {
    let {user} = useUserContext();

	let blankForm = {
		merchantFile:''
	}
	let [uploadForm, setUploadForm] = useState(blankForm);

	let [showSpinner, setSpinner] = useState(false);
	let [message, setMessage] = useState();

	let handleFileChange = (event) => {
		let cloned = {...uploadForm};
		cloned.merchantFile = event.target.files[0];
		setUploadForm(cloned);
	}

	let handleSubmit = (e) => {
		e.preventDefault();

		console.debug('file size ' + uploadForm.merchantFile.size);
		const maxSize = 1024 * 1024;
		if (uploadForm.merchantFile.size > maxSize) {
			setMessage({text:'Merchant file size cannot be greater than 1MB.',type:'warning'});
			return false;
		}
		setSpinner(true);

		let url = getMerchantsApiUrl() + '/merchant/file';
		let formData = new FormData();
		formData.append('merchantFile', uploadForm.merchantFile);
        console.log(formData);

		apiPostFile(url, formData).then((resp)=> {
			console.debug(resp);
			//setUploadForm(blankForm);
			let messageObject = {text:'Merchant file processed.',type:'success'};
			let messages = [];
			if(resp && resp.processed)
				messages.push(resp.processed + ' merchant rows processed.');
			if(resp && resp.added)
				messages.push(resp.added + ' merchant(s) added.');
			if(resp && resp.updated)
				messages.push(resp.updated + ' merchant(s) updated.');

			let messageText = messages.map( (value, index) => <div key={index}>{value}</div>);
			messageObject.text = <>{messageText}</>;

			setMessage(messageObject);
		}).catch( (err)=> {
			console.error(err);
			let messageObject = {text:Strings.error.general,type:'danger'};
			if(err.privilegeError){
				messageObject.text = <>{err.message}</>;
			} else if(err.status == 400 || err.status == 409) {
				console.error(err.data.errorMessages);
				if(err.data.expandedErrors && err.data.expandedErrors.length){
					let messages = err.data.expandedErrors.map( (value, index) => <div key={index}>{value.appErrorMessage}</div>);
					messageObject.text = <>{messages}</>;
				}
				else if(err.data.errorMessages && err.data.errorMessages.length){
					let messages = err.data.errorMessages.map( (value, index) => <div key={index}>{value.appErrorMessage}</div>);
					messageObject.text = <>{messages}</>;
				}
			} else if (err.status == 422){
				messageObject = {text:'Invalid file content.',type:'danger'};
			}
			setMessage(messageObject);
		}).finally(() => setSpinner(false));
	};

	let [showSection, setShowSection] = useState(0);

	let InfoSection = () => {
		if (showSection == 1) {
			return <>
			<table className='table table-sm col-12 col-md-6'>
				<thead>
					<tr><th>Action Code</th><th>Description</th><th><button type="button" className='btn btn-info btn-sm pull-right' onClick={() => setShowSection(0)}><i class="fa fa-window-close" aria-hidden="true"></i></button></th></tr>
				</thead>
				<tbody>
					<tr><th>01</th><td colSpan={2}>Add Active Merchant</td></tr>
					<tr><th>02</th><td colSpan={2}>Add Inactive Merchant</td></tr>
					<tr><th>03</th><td colSpan={2}>Disable Merchant</td></tr>
					<tr><th>04</th><td colSpan={2}>Update Merchant</td></tr>
					<tr><th>05</th><td colSpan={2}>Update Merchant Bank Info</td></tr>
				</tbody>
			</table>
			</>
		}

		return null;
	};

	let listStyle = {listStyleType:'none',margin:'.2em .2em 1em .2em',padding:'.2em'};

	return (
		<>
		<Processing show={showSpinner} />

		<h3>Upload Merchant File</h3>
        <MessageTag message={message} />
		
		<ul style={listStyle}>
			<li className='text-info'>April 2025: Action Codes updated. Program Identifier changed to Program Short Name.
			</li>
			<li className='text-info'>May 2025: Merchant Identifier optional.
			</li>
		</ul>

		<label style={{fontStyle: 'italic', fontSize: '.9em'}}>Merchant Files need to be CSV or Excel files in a specific format. <br /> Example files are available for download below for assistance. </label>

		<div>	
			<a href="/ExampleMerchantFiles/MerchantFileExample.csv" download="MerchantFileExample.csv">Download Example CSV File</a>
			<br />
			<a href="/ExampleMerchantFiles/MerchantFileExample.xlsx" download="MerchantFileExample.xlsx">Download Example Excel File</a>
		</div>

		<br/>

        <form onSubmit={handleSubmit}>
			<div className="row">
				<div className="form-group col-12 col-md-6">
					<label htmlFor="merchantFile" className="btn btn-info">Select Merchant File <input type="file" id="merchantFile" name="merchantFile" className="form-control-file d-none" onChange={handleFileChange} required accept=".csv,.xls,.xlsx"/></label>
					<br/><h4>&nbsp;{uploadForm.merchantFile.name}</h4>
				</div>
			</div>
			<button className="btn btn-primary">Upload File</button>
		</form>

		<br/>
		<hr/>

		<br/>
		<table className='table table-sm col-12 col-md-6'>
			<thead>
				<tr><th>Action Code</th><th>Description</th></tr>
			</thead>
			<tbody>
				<tr><td>01</td><td>Add Active Merchant</td></tr>
				<tr><td>02</td><td>Add Inactive Merchant</td></tr>
				<tr><td>03</td><td>Disable Merchant</td></tr>
				<tr><td>04</td><td>Update Merchant</td></tr>
				<tr><td>05</td><td>Update Merchant Bank Info</td></tr>
			</tbody>
		</table>

		<br/>
		<table className='table table-sm col-12 col-md-6'>
			<thead>
				<tr><th>Tax ID Type</th></tr>
			</thead>
			<tbody>
				<tr><td>SSN</td></tr>
				<tr><td>EIN</td></tr>
			</tbody>
		</table>

		<br/>
		<table className='table table-sm col-12 col-md-6'>
			<thead>
				<tr><th>Tax Classification</th></tr>
			</thead>
			<tbody>
				<tr><td>Individual (Sole Proprietor)</td></tr>
				<tr><td>C Corp</td></tr>
				<tr><td>S Corp</td></tr>
				<tr><td>Partnership</td></tr>
				<tr><td>Trust/Estate</td></tr>
				<tr><td>LLC</td></tr>
				<tr><td>Other</td></tr>
			</tbody>
		</table>

		<br/>
		<table className='table table-sm col-12 col-md-6'>
			<thead>
				<tr><th>Bank Accout Type</th></tr>
			</thead>
			<tbody>
				<tr><td>Checking</td></tr>
				<tr><td>Savings</td></tr>
			</tbody>
		</table>

		<br/>
		<table className='table table-sm col-12 col-md-6'>
			<thead>
				<tr><th>Optional Fields</th></tr>
			</thead>
			<tbody>
				<tr><td>Bank Name</td></tr>
				<tr><td>Bank Account Number</td></tr>
				<tr><td>Bank Routing Number</td></tr>
				<tr><td>Bank Account Type</td></tr>
				<tr><td>Bank Account Holder First, Middle, Last Name</td></tr>
				<tr><td>Federal Tax ID</td></tr>
				<tr><td>FNS Number</td></tr>
				<tr><td>Physical Address</td></tr>
				<tr><td>Merchant Identifier</td></tr>
			</tbody>
		</table>

		</>
	)
}
